import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CSSObject,
  styled,
  Theme,
  Typography,
} from '@mui/material';
import React from 'react';

import ExpandIcon from '@/assets/icons/dropdown-arrow.svg?react';
import { TransactionDetails } from '@/components/organisms/TransactionDetails';
import { Simulation } from '@/hooks/useSimulation';
import { useTranslator } from '@/hooks/useTranslator';
import { CurrencyCodeType } from '@/types/currency';

interface Props {
  simulating: boolean;
  simulation: Simulation;
  fromAmount: number | null;
  fromCurrency: CurrencyCodeType;
}

export const TransactionDetailsAccordion: React.FC<Props> = (props: Props): React.ReactElement => {
  const { simulation, simulating, fromAmount, fromCurrency } = props;
  const tr = useTranslator();

  return (
    <StyledAccordion disabled={simulating}>
      <AccordionSummary expandIcon={<ExpandIcon />}>
        <Typography variant="h7">{tr('TRANSACTION_DETAILS')}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TransactionDetails
          transactionDetails={simulation.transactionDetails}
          fromAmount={fromAmount}
          fromCurrency={fromCurrency}
          toAmount={simulation.to.value}
          toCurrency={simulation.to.currencyCode}
          validityTimestamp={simulation.expiresAt}
        />
      </AccordionDetails>
    </StyledAccordion>
  );
};

const StyledAccordion = styled(Accordion)(
  ({ theme }: { theme: Theme }): CSSObject => ({
    border: 'none',
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.custom.DividerLight,
    borderRadius: 16,
    '&::before': {
      display: 'none',
    },
    '&:last-of-type': {
      borderRadius: 16,
    },
  }),
);
